/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ring_PartnersInputs */

const en_ring_partners = /** @type {(inputs: Ring_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands and suppliers`)
};

/**
* | output |
* | --- |
* | "Brands and suppliers" |
*
* @param {Ring_PartnersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ring_partners = /** @type {((inputs?: Ring_PartnersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ring_PartnersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ring_partners(inputs)
});